import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { cn } from '@/lib/utils';

interface User {
  name: string;
  email?: string | null;
  id: string;
  avatar?: string | null;
}

export const avatarSizeClasses = {
  sm: 'size-6',
  md: 'size-8',
  lg: 'size-10',
};

function getInitials(name: string) {
  const parts = name.split(' ').filter((part) => part.length > 0);
  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase();
  } else if (parts.length === 2) {
    return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
  } else {
    // For 3+ parts, use first and last
    return (
      parts[0].charAt(0) + parts[parts.length - 1].charAt(0)
    ).toUpperCase();
  }
}

export const AvatarWithFallback = ({
  user,
  className,
  size = 'md',
}: {
  user: User;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}) => {
  return (
    <Avatar className={cn(avatarSizeClasses[size], className)}>
      {user.avatar && <AvatarImage src={user.avatar} alt={user.name} />}
      <AvatarFallback className="text-xs font-medium bg-muted">
        {getInitials(user.name)}
      </AvatarFallback>
    </Avatar>
  );
};
